import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=1e835556&scoped=true"
import script from "./classification.vue?vue&type=script&lang=ts"
export * from "./classification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e835556",
  null
  
)

export default component.exports